// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-food {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin: 2vw auto;
  overflow: visible;
  min-width: 94vw;
  max-width: 94vw;
  border-radius: 0px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: content-box;
  transition: all 0.5s ease-in-out;
  height: 60vw;
  box-shadow: none;
}
.selected-food .contentInner {
  padding: 0;
  background-size: 200% 200%;
  background-position: 0 100%;
  display: flex;
  overflow: auto;
  position: relative;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  flex-direction: column;
  width: 100%;
  height: 60vw;
  border-radius: 15px;
  box-shadow: var(--shadow-m);
}
.selected-food .contentInner .itemText {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 20vw;
}
.selected-food .contentInner .itemText .title {
  white-space: normal;
  letter-spacing: 1px;
  color: var(--ion-black-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.5s ease-in-out;
  padding: 1vw;
  overflow: auto;
  margin: 0;
  min-height: 8vw;
  margin: 1vw;
  min-height: 8vw;
  font-weight: 600;
  font-size: 16px;
}
.selected-food .contentInner .itemText .desc {
  white-space: normal;
  color: var(--ion-black-primary);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 90%;
  font-weight: 300;
  text-align: center;
  transition: all 0.5s ease-in-out;
  overflow: auto;
  opacity: 1;
  font-size: 12px;
}
.selected-food .contentInner .footerBlock {
  padding: 0;
  background: var(--ion-white-primary);
  display: flex;
  overflow: auto;
  position: relative;
  justify-content: space-between;
  transition: all 0.5s ease-in-out;
  flex-direction: column;
  width: 96%;
  height: 40vw;
  box-shadow: none;
  margin: 2vw auto;
  border-radius: 13px;
  gap: 2vw;
  border: 1px solid var(--ion-fade-secondary);
}
.selected-food .contentInner .footerBlock .progressDur {
  width: calc(100% - 4vw);
  margin: 0 auto;
  height: 5vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 13px;
  border: 1px solid var(--ion-ultra-primary);
  background: var(--ion-white-primary);
}
.selected-food .contentInner .footerBlock .progressDur .progress {
  background: linear-gradient(24deg, var(--ion-warm-primary) 0%, var(--ion-fade-primary) 50%, var(--ion-color-primary) 100%);
  background-size: 200% 200%;
  background-position: 0 100%;
  height: 3vw;
  border-radius: 13px;
  margin: 1vw;
  transition: width 1s ease-out;
  animation: pulse-width 8s infinite alternate ease-in-out;
}
.selected-food .contentInner .footerBlock .typeTag {
  opacity: 1;
  padding: 0px;
  margin: 0vw auto;
  background: none;
  position: relative;
  z-index: 2;
  border-radius: 0px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: calc(100% - 4vw);
  height: 15vw;
  background: transparent;
  margin-top: 2vw;
}
.selected-food .contentInner .footerBlock .typeTag .mealType {
  margin: 0vw;
  background: transparent;
  display: flex;
  flex-direction: row;
  border-radius: 0px;
  justify-content: space-between;
  align-items: center;
  height: 6vw;
  width: 100%;
}
.selected-food .contentInner .footerBlock .typeTag .mealType .mealText {
  padding: 0;
  margin: 0vw;
  background: transparent;
  display: flex;
  border-radius: 7px;
  justify-content: center;
  align-items: center;
  height: 6vw;
  font-size: 12px;
  letter-spacing: 1px;
  gap: 2vw;
}
.selected-food .contentInner .footerBlock .typeTag .mealType .mealText .mealContainer {
  padding: 1vw 2vw;
  margin: 0vw;
  display: flex;
  border-radius: 7px;
  justify-content: center;
  align-items: center;
  height: 6vw;
  font-size: 12px;
  letter-spacing: 1px;
  min-width: 25vw;
}
.selected-food .contentInner .footerBlock .typeTag .mealType .mealText .snackCat {
  background: var(--ion-ultra-tertiary);
  color: var(--ion-color-tertiary);
}
.selected-food .contentInner .footerBlock .typeTag .mealType .mealText .mealCat {
  background: var(--ion-ultra-secondary);
  color: var(--ion-color-secondary);
}
.selected-food .contentInner .footerBlock .typeTag .mealType .price {
  padding: 1vw 2vw;
  font-size: 16px;
  transition: all 0.5s ease-in-out;
  background: transparent;
  color: var(--ion-color-success);
  border-radius: 7px;
  border: 1px solid var(--ion-color-success);
  height: 6vw;
  display: flex;
  margin: 0vw;
  align-items: center;
  justify-content: center;
  gap: 1vw;
  letter-spacing: 1px;
  min-width: 33%;
}
.selected-food .contentInner .footerBlock .typeTag .mealType .price .smallP {
  font-size: 12px;
  color: var(--ion-color-success);
}
.selected-food .contentInner .footerBlock .typeTag .subDates {
  color: var(--ion-black-primary);
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  gap: 0vw;
  text-align: center;
  transition: all 0.5s ease-in-out;
  opacity: 1;
  line-height: 1;
  font-size: 11px;
  letter-spacing: 1px;
  width: 100%;
}
.selected-food .contentInner .footerBlock .typeTag .subDates .progressTextI {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
.selected-food .contentInner .footerBlock .typeTag .subDates .progressTextI .progressText {
  color: var(--ion-dark-danger);
  font-size: 12px;
  margin: 0 0.5vw;
  font-weight: 500;
}
.selected-food .contentInner .footerBlock .btnBarBottom {
  display: flex;
  justify-content: space-between;
  justify-items: center;
  align-items: flex-end;
  position: relative;
  transform-origin: bottom;
  z-index: 2;
  background: transparent;
  margin: 0 2vw;
  border-radius: 15px;
  height: 10vw;
  width: calc(100% - 4vw);
  transition: all 0.5s ease-in-out;
  opacity: 1;
  pointer-events: auto;
  gap: 2vw;
  margin-bottom: 2vw;
}
.selected-food .contentInner .footerBlock .btnBarBottom .mainBtnBottom {
  height: 7vw;
  width: 100%;
  margin: 0vw 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 2vw;
  padding: 1vw 2vw;
  border-radius: 8px;
  justify-content: center;
  z-index: 1;
  box-shadow: var(--shadow-l);
  pointer-events: all;
  font-size: 12px;
  text-transform: capitalize;
  letter-spacing: 1px;
}
.selected-food .contentInner .footerBlock .btnBarBottom .mainBtnBottom .smallIcon {
  width: 5vw;
  height: 5vw;
}
.selected-food .contentInner .footerBlock .btnBarBottom .freezeSub {
  background: var(--ion-pass-info);
  color: var(--ion-color-info);
}
.selected-food .contentInner .footerBlock .btnBarBottom .freezeSub .smallIcon {
  stroke: var(--ion-color-info);
}
.selected-food .contentInner .footerBlock .btnBarBottom .cancelSub {
  background: var(--ion-pass-danger);
  color: var(--ion-color-danger);
}
.selected-food .contentInner .footerBlock .btnBarBottom .cancelSub .smallIcon {
  stroke: var(--ion-color-danger);
}
.selected-food .contentInner .footerBlock .btnBarBottom .upgradeSub {
  background: var(--ion-pass-warning);
  color: var(--ion-dark-warning);
}
.selected-food .contentInner .footerBlock .btnBarBottom .upgradeSub .smallIcon {
  stroke: var(--ion-dark-warning);
}
.selected-food .contentInner .footerBlock .btnBarBottom .payNowSub {
  background: var(--ion-pass-success);
  color: var(--ion-color-success);
}
.selected-food .contentInner .footerBlock .btnBarBottom .payNowSub .smallIcon {
  stroke: var(--ion-color-success);
}
.selected-food .contentInner .footerBlock .btnBarBottom .renewSub {
  background: var(--ion-pass-tertiary);
  color: var(--ion-color-tertiary);
}
.selected-food .contentInner .footerBlock .btnBarBottom .renewSub .smallIcon {
  stroke: var(--ion-color-tertiary);
}
.selected-food .contentInner .footerBlock .btnBarBottom .hideSub {
  opacity: 0;
  background: var(--ion-color-tertiary);
  color: var(--ion-text-tertiary);
}
.selected-food .contentInner .footerBlock .btnBarBottom .hideSub .smallIcon {
  stroke: var(--ion-text-tertiary);
}
.selected-food .activeContent {
  background: linear-gradient(180deg, var(--ion-bareLight-primary) 0%, var(--ion-washed-primary) 50%, var(--ion-pass-primary) 100%);
}
.selected-food .pendingContent {
  background: linear-gradient(0deg, var(--ion-bareLight-warning) 0%, var(--ion-washed-warning) 50%, var(--ion-pass-warning) 100%);
}
.selected-food .pendingContent .footerBlock {
  border: 1px solid var(--ion-fade-warning);
}
.selected-food .pendingContent .footerBlock .progressDur {
  opacity: 0;
  height: 0;
}
.selected-food .pendingContent .footerBlock .typeTag .mealType .price {
  border: 1px solid var(--ion-text-warning);
  color: var(--ion-text-warning);
  background-color: var(--ion-color-warning);
}
.selected-food .pendingContent .footerBlock .typeTag .mealType .price .smallP {
  color: var(--ion-text-warning);
}

:host {
  display: flex;
  height: 100%;
  background: transparent;
  z-index: 1;
  position: relative;
}

* {
  font-family: var(--ion-font-family);
}

@keyframes pulse-width {
  0% {
    transform: scaleX(0.98);
    transform-origin: left;
    background-position: 0% 100%;
  }
  100% {
    transform: scaleX(1.02);
    transform-origin: left;
    background-position: 100% 0%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-subscription-card/my-subscription-card.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EAGA,wCAAA;EACA,uBAAA;EACA,gCAAA;EACA,YAAA;EAEA,gBAAA;AAFD;AAKC;EACC,UAAA;EAEA,0BAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;AAJF;AAME;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAJH;AAMG;EACC,mBAAA;EACA,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAJJ;AAQG;EACC,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;EACA,cAAA;EACA,UAAA;EAIA,eAAA;AATJ;AAkBE;EACC,UAAA;EACA,oCAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,8BAAA;EACA,gCAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,2CAAA;AAhBH;AAkBG;EACC,uBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;AAhBJ;AAkBI;EAEC,0HAAA;EACA,0BAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,wDAAA;AAjBL;AAsCG;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AApCJ;AAsCI;EAUC,WAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EAEA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;AA9CL;AAgDK;EACC,UAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AA9CN;AAgDM;EACC,gBAAA;EACA,WAAA;EAEA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACI,eAAA;AA/CX;AAkDM;EACC,qCAAA;EACA,gCAAA;AAhDP;AAmDM;EACC,sCAAA;EACA,iCAAA;AAjDP;AAqDK;EAEC,gBAAA;EACA,eAAA;EAKA,gCAAA;EAEA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,0CAAA;EACA,WAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AAzDN;AA2DM;EACC,eAAA;EACA,+BAAA;AAzDP;AAgEI;EAEC,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,QAAA;EAEA,kBAAA;EACA,gCAAA;EAEA,UAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAjEL;AAmEK;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAjEN;AAmEM;EACC,6BAAA;EACA,eAAA;EACA,eAAA;EAEA,gBAAA;AAlEP;AA8FG;EACC,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;AA5FJ;AA8FI;EAEC,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AA7FL;AA+FK;EACC,UAAA;EACA,WAAA;AA7FN;AAmGI;EAEC,gCAAA;EACA,4BAAA;AAlGL;AAoGK;EACC,6BAAA;AAlGN;AAsGI;EACC,kCAAA;EACA,8BAAA;AApGL;AAsGK;EACC,+BAAA;AApGN;AAwGI;EACC,mCAAA;EACA,8BAAA;AAtGL;AAwGK;EACC,+BAAA;AAtGN;AA0GI;EACC,mCAAA;EACA,+BAAA;AAxGL;AA0GK;EACC,gCAAA;AAxGN;AA4GI;EACC,oCAAA;EACA,gCAAA;AA1GL;AA4GK;EACC,iCAAA;AA1GN;AA8GI;EACC,UAAA;EACA,qCAAA;EACA,+BAAA;AA5GL;AA8GK;EACC,gCAAA;AA5GN;AAoHC;EACC,iIAAA;AAlHF;AAqHC;EACC,+HAAA;AAnHF;AAqHE;EACC,yCAAA;AAnHH;AAqHG;EACC,UAAA;EACA,SAAA;AAnHJ;AAwHK;EACC,yCAAA;EACA,8BAAA;EACA,0CAAA;AAtHN;AAwHM;EACC,8BAAA;AAtHP;;AA+HA;EACC,aAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AA5HD;;AA+HA;EACC,mCAAA;AA5HD;;AA+HA;EACC;IAGC,uBAAA;IACA,sBAAA;IACA,4BAAA;EA9HA;EAiID;IAEC,uBAAA;IACA,sBAAA;IACA,4BAAA;EAhIA;AACF","sourcesContent":[".selected-food {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\tpadding: 0;\n\tmargin: 2vw auto;\n\toverflow: visible;\n\tmin-width: 94vw;\n\tmax-width: 94vw;\n\tborder-radius: 0px;\n\t// background: linear-gradient(90deg, hsl(var(--drop-washed-primary)/0.3) 0%, #fff0 40%, #fff 65%, var(--ion-pass-primary) 100%);\n\t// background-size: 200%;\n\tbackground-color: #fff0;\n\tbox-sizing: content-box;\n\ttransition: all 0.5s ease-in-out;\n\theight: 60vw;\n\t// box-shadow: 2px 2px 20px -10px var(--ion-color-primary);\n\tbox-shadow: none;\n\n\n\t.contentInner {\n\t\tpadding: 0;\n\t\t// background: linear-gradient(180deg, var(--ion-bareLight-primary) 0%, var(--ion-washed-primary) 50%, var(--ion-pass-primary) 100%);\n\t\tbackground-size: 200% 200%;\n\t\tbackground-position: 0 100%;\n\t\tdisplay: flex;\n\t\toverflow: auto;\n\t\tposition: relative;\n\t\tjustify-content: center;\n\t\ttransition: all 0.5s ease-in-out;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\theight: 60vw;\n\t\tborder-radius: 15px;\n\t\tbox-shadow: var(--shadow-m);\n\n\t\t.itemText {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 20vw;\n\n\t\t\t.title {\n\t\t\t\twhite-space: normal;\n\t\t\t\tletter-spacing: 1px;\n\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\ttext-align: center;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\tpadding: 1vw;\n\t\t\t\toverflow: auto;\n\t\t\t\tmargin: 0;\n\t\t\t\tmin-height: 8vw;\n\t\t\t\tmargin: 1vw;\n\t\t\t\tmin-height: 8vw;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tfont-size: 16px;\n\n\t\t\t}\n\n\t\t\t.desc {\n\t\t\t\twhite-space: normal;\n\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tjustify-content: center;\n\t\t\t\twidth: 90%;\n\t\t\t\tfont-weight: 300;\n\t\t\t\ttext-align: center;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\toverflow: auto;\n\t\t\t\topacity: 1;\n\t\t\t\t// max-height: calc(100% - 15vw);\n\t\t\t\t// min-height: calc(100% - 15vw);\n\n\t\t\t\tfont-size: 12px;\n\t\t\t}\n\n\n\n\n\n\t\t}\n\n\t\t.footerBlock {\n\t\t\tpadding: 0;\n\t\t\tbackground: var(--ion-white-primary);\n\t\t\tdisplay: flex;\n\t\t\toverflow: auto;\n\t\t\tposition: relative;\n\t\t\tjustify-content: space-between;\n\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\tflex-direction: column;\n\t\t\twidth: 96%;\n\t\t\theight: 40vw;\n\t\t\tbox-shadow: none;\n\t\t\tmargin: 2vw auto;\n\t\t\tborder-radius: 13px;\n\t\t\tgap: 2vw;\n\t\t\tborder: 1px solid var(--ion-fade-secondary);\n\n\t\t\t.progressDur {\n\t\t\t\twidth: calc(100% - 4vw);\n\t\t\t\tmargin: 0 auto;\n\t\t\t\theight: 5vw;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\t\t\t\toverflow: hidden;\n\t\t\t\tborder-radius: 13px;\n\t\t\t\tborder: 1px solid var(--ion-ultra-primary);\n\t\t\t\tbackground: var(--ion-white-primary);\n\n\t\t\t\t.progress {\n\t\t\t\t\t// background: var(--ion-half-primary);\n\t\t\t\t\tbackground: linear-gradient(24deg, var(--ion-warm-primary) 0%, var(--ion-fade-primary) 50%, var(--ion-color-primary) 100%);\n\t\t\t\t\tbackground-size: 200% 200%;\n\t\t\t\t\tbackground-position: 0 100%;\n\t\t\t\t\theight: 3vw;\n\t\t\t\t\tborder-radius: 13px;\n\t\t\t\t\tmargin: 1vw;\n\t\t\t\t\ttransition: width 1s ease-out; // Smooth transition for width changes\n\t\t\t\t\tanimation: pulse-width 8s infinite alternate ease-in-out;\n\n\t\t\t\t}\n\n\t\t\t\t// .progressText {\n\t\t\t\t// \tcolor: var(--ion-white-primary);\n\t\t\t\t// \tfont-size: 12px;\n\t\t\t\t// \tfont-weight: 500;\n\t\t\t\t// \tmargin: 0 1vw;\n\t\t\t\t// \tletter-spacing: 1px;\n\t\t\t\t// \topacity: 1;\n\t\t\t\t// \tposition: absolute;\n\t\t\t\t// \tright: 0vw;\n\t\t\t\t// \tpadding: 0 2vw;\n\t\t\t\t// \tborder-radius: 13px;\n\t\t\t\t// \tline-height: 1;\n\t\t\t\t// \theight: 3vw;\n\t\t\t\t// \tbackground: hsl(var(--drop-black-grey) / 0.5);\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\topacity: 1;\n\t\t\t\tpadding: 0px;\n\t\t\t\tmargin: 0vw auto;\n\t\t\t\tbackground: none;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 2;\n\t\t\t\tborder-radius: 0px;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tflex-direction: column;\n\t\t\t\twidth: calc(100% - 4vw);\n\t\t\t\theight: 15vw;\n\t\t\t\tbackground: transparent;\n\t\t\t\tmargin-top: 2vw;\n\n\t\t\t\t.mealType {\n\t\t\t\t\t// padding: 0 1vw;\n\t\t\t\t\t// margin: 0vw;\n\t\t\t\t\t// background: var(--ion-diffuseLight-primary);\n\t\t\t\t\t// // min-height: 3vw;\n\t\t\t\t\t// display: flex;\n\t\t\t\t\t// justify-content: center;\n\t\t\t\t\t// align-items: center;\n\n\t\t\t\t\t// padding: 1vw 2vw;\n\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tborder-radius: 0px;\n\t\t\t\t\t// justify-content: center;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\theight: 6vw;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t.mealText {\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\theight: 6vw;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tgap: 2vw;\n\n\t\t\t\t\t\t.mealContainer {\n\t\t\t\t\t\t\tpadding: 1vw 2vw;\n\t\t\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\t\t\t// background: var(--ion-ultra-secondary);\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\theight: 6vw;\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\t\t    min-width: 25vw;\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.snackCat {\n\t\t\t\t\t\t\tbackground: var(--ion-ultra-tertiary);\n\t\t\t\t\t\t\tcolor: var(--ion-color-tertiary);\n\t\t\t\t\t\t}\n\n\t\t\t\t\t\t.mealCat {\n\t\t\t\t\t\t\tbackground: var(--ion-ultra-secondary);\n\t\t\t\t\t\t\tcolor: var(--ion-color-secondary);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.price {\n\t\t\t\t\t\t// height: 7vw;\n\t\t\t\t\t\tpadding: 1vw 2vw;\n\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t// width: -moz-fit-content;\n\t\t\t\t\t\t// width: fit-content;\n\t\t\t\t\t\t// margin: 2vw;\n\t\t\t\t\t\t// align-self: flex-end;\n\t\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\t\t// scale: 1;\n\t\t\t\t\t\tbackground: transparent;\n\t\t\t\t\t\tcolor: var(--ion-color-success);\n\t\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t\t\tborder: 1px solid var(--ion-color-success);\n\t\t\t\t\t\theight: 6vw;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\tgap: 1vw;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tmin-width: 33%;\n\n\t\t\t\t\t\t.smallP {\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tcolor: var(--ion-color-success);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\n\t\t\t\t}\n\n\t\t\t\t.subDates {\n\t\t\t\t\t// white-space: normal;\n\t\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-around;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tgap: 0vw;\n\t\t\t\t\t// font-weight: 300;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\t// overflow: auto;\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tline-height: 1;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t.progressTextI {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\tflex-direction: row;\n\n\t\t\t\t\t\t.progressText {\n\t\t\t\t\t\t\tcolor: var(--ion-dark-danger);\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tmargin: 0 0.5vw;\n\t\t\t\t\t\t\t// font-size: 11px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\t// margin: 0vw;\n\t\t\t\t\t\t\t// letter-spacing: 1px;\n\t\t\t\t\t\t\t// opacity: 1;\n\t\t\t\t\t\t\t// position: relative;\n\t\t\t\t\t\t\t// // right: 0vw;\n\t\t\t\t\t\t\t// padding: 0 1vw;\n\t\t\t\t\t\t\t// border-radius: 13px;\n\t\t\t\t\t\t\t// line-height: 1;\n\t\t\t\t\t\t\t// height: 3vw;\n\t\t\t\t\t\t\t// background: hsl(var(--drop-black-grey) / 0.5);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t// padding: 1vw 2vw;\n\t\t\t\t\t// margin: 0vw;\n\t\t\t\t\t// background: transparent;\n\t\t\t\t\t// display: flex;\n\t\t\t\t\t// border-radius: 15px;\n\t\t\t\t\t// justify-content: center;\n\t\t\t\t\t// align-items: center;\n\t\t\t\t\t// height: 6vw;\n\t\t\t\t\t// font-size: 12px;\n\t\t\t\t\t// letter-spacing: 1px;\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t\t.btnBarBottom {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tjustify-items: center;\n\t\t\t\talign-items: flex-end;\n\t\t\t\tposition: relative;\n\t\t\t\ttransform-origin: bottom;\n\t\t\t\tz-index: 2;\n\t\t\t\tbackground: transparent;\n\t\t\t\tmargin: 0 2vw;\n\t\t\t\tborder-radius: 15px;\n\t\t\t\theight: 10vw;\n\t\t\t\twidth: calc(100% - 4vw);\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\topacity: 1;\n\t\t\t\tpointer-events: auto;\n\t\t\t\tgap: 2vw;\n\t\t\t\tmargin-bottom: 2vw;\n\n\t\t\t\t.mainBtnBottom {\n\t\t\t\t\t// for substraction\n\t\t\t\t\theight: 7vw;\n\t\t\t\t\twidth: 100%;\n\t\t\t\t\tmargin: 0vw 0;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tgap: 2vw;\n\t\t\t\t\tpadding: 1vw 2vw;\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\tbox-shadow: var(--shadow-l);\n\t\t\t\t\tpointer-events: all;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\ttext-transform: capitalize;\n\t\t\t\t\tletter-spacing: 1px;\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\twidth: 5vw;\n\t\t\t\t\t\theight: 5vw;\n\t\t\t\t\t}\n\n\n\t\t\t\t}\n\n\t\t\t\t.freezeSub {\n\t\t\t\t\t// background: var(--ion-text-info);\n\t\t\t\t\tbackground: var(--ion-pass-info);\n\t\t\t\t\tcolor: var(--ion-color-info);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-color-info);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.cancelSub {\n\t\t\t\t\tbackground: var(--ion-pass-danger);\n\t\t\t\t\tcolor: var(--ion-color-danger);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-color-danger);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.upgradeSub {\n\t\t\t\t\tbackground: var(--ion-pass-warning);\n\t\t\t\t\tcolor: var(--ion-dark-warning);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-dark-warning);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.payNowSub {\n\t\t\t\t\tbackground: var(--ion-pass-success);\n\t\t\t\t\tcolor: var(--ion-color-success);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-color-success);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.renewSub {\n\t\t\t\t\tbackground: var(--ion-pass-tertiary);\n\t\t\t\t\tcolor: var(--ion-color-tertiary);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-color-tertiary);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.hideSub {\n\t\t\t\t\topacity: 0;\n\t\t\t\t\tbackground: var(--ion-color-tertiary);\n\t\t\t\t\tcolor: var(--ion-text-tertiary);\n\n\t\t\t\t\t.smallIcon {\n\t\t\t\t\t\tstroke: var(--ion-text-tertiary);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\t}\n\n\t.activeContent {\n\t\tbackground: linear-gradient(180deg, var(--ion-bareLight-primary) 0%, var(--ion-washed-primary) 50%, var(--ion-pass-primary) 100%);\n\t}\n\n\t.pendingContent {\n\t\tbackground: linear-gradient(0deg, var(--ion-bareLight-warning) 0%, var(--ion-washed-warning) 50%, var(--ion-pass-warning) 100%);\n\n\t\t.footerBlock {\n\t\t\tborder: 1px solid var(--ion-fade-warning);\n\n\t\t\t.progressDur {\n\t\t\t\topacity: 0;\n\t\t\t\theight: 0;\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\t.mealType {\n\t\t\t\t\t.price {\n\t\t\t\t\t\tborder: 1px solid var(--ion-text-warning);\n\t\t\t\t\t\tcolor: var(--ion-text-warning);\n\t\t\t\t\t\tbackground-color: var(--ion-color-warning);\n\n\t\t\t\t\t\t.smallP {\n\t\t\t\t\t\t\tcolor: var(--ion-text-warning);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n:host {\n\tdisplay: flex;\n\theight: 100%;\n\tbackground: transparent;\n\tz-index: 1;\n\tposition: relative;\n}\n\n* {\n\tfont-family: var(--ion-font-family);\n}\n\n@keyframes pulse-width {\n\t0% {\n\t\t// This calculates 5% less than the actual target width\n\t\t// The min(100vw, ...) is a safeguard for extreme values, though not strictly needed for percentage\n\t\ttransform: scaleX(0.98); // Scale down to 95% of its set width\n\t\ttransform-origin: left; // Scale from the left edge\n\t\tbackground-position: 0% 100%;\n\t}\n\n\t100% {\n\t\t// This calculates 5% more than the actual target width\n\t\ttransform: scaleX(1.02); // Scale up to 105% of its set width\n\t\ttransform-origin: left; // Scale from the left edge\n\t\tbackground-position: 100% 0%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
